import React from 'react';
import style from './LeaderBoardsModal.module.css';
import Modal from '../Modal/Modal';
import RoutineMemberCard from '../RoutineMemberCard/RoutineMemberCard';

const LeaderBoardsModal = ({ onClose, people }) => {
	const sortedPeople = [...(people || [])].sort((a, b) => (b.userRoutineXP || 0) - (a.userRoutineXP || 0));

	return (
		<Modal
			onClose={onClose}
			title='Leaderboard'
			subtitle='Current ranking for this routine based on XP earned.'
			maxWidth={620}
		>
			<div className={style.LeaderboardsWrapper}>
				{sortedPeople.length > 0 ? sortedPeople.map(person => (
					<RoutineMemberCard
						key={person.userID}
						name={person.username}
						image={person.profileImageLink}
						xp={person.userRoutineXP}
					/>
				)) : (
					<p className={style.EmptyText}>No participants to rank yet.</p>
				)}
			</div>
		</Modal>
	);
};

export default LeaderBoardsModal;